.thread-list-sidebar-header {
    background-color: var(--off-white);
    padding: 12px 12px 8px 12px;
}
